// extracted by mini-css-extract-plugin
export default {"gradientOptions":"BackgroundOptions_gradientOptions__z39SO","solidBgOption":"BackgroundOptions_solidBgOption__0CBsS","visible":"BackgroundOptions_visible__fXrjx"};